import gql from 'graphql-tag';
import { FAMILY_HEADER_MEDIA_FRAGMENT } from './FamilyHeaderMedia';

export const FONT_FAMILY_QUERY = gql`
  query FontFamilyQuery($slug: String!, $language: Language!) {
    fontFamily(slug: $slug) {
      id
      slug
      name
      completePrice
      fontFacePrice
      subPackageFontFacePrice
      discountedFontFacePrice
      description(language: $language)
      supportedLanguages(language: $language)
      micrositeUrl
      specimenDocumentUrl
      conceptFont
      backgroundColor
      textColor
      hideFontFacePreviews
      hasWidthVariableFiles

      characterSetImage {
        url
        width
        height
      }

      ...FamilyHeaderMediaFragment

      faces {
        id
        size {
          id
          slug
          name(language: $language)
          position
        }
        width {
          id
          slug
          name(language: $language)
          position
        }
        weight {
          id
          slug
          name(language: $language)
          position
        }
        style {
          id
          slug
          name(language: $language)
          position
        }

        description(language: $language)
        familyPreview {
          url
          width
          height
        }
        singlePreview {
          url
        }
        singleCharacterPreview {
          url
        }
        cssClassName

        family {
          id
          fontFacePrice
          discountedFontFacePrice
        }
      }

      typeTesters {
        id
        position
        faceId
        content
        fontSize
        lineHeight
        openTypeFeatures
      }

      features {
        id
        name(language: $language)
        image {
          url
        }
      }

      usageExamples(first: 4) {
        id
        title
        designers
        permalink
        image {
          url
          width
          height
        }
      }
    }
  }

  ${FAMILY_HEADER_MEDIA_FRAGMENT}
`;
